import React, {useState} from 'react'
import './Searchbar.css'
import Searchicon from '../Assets/Searchicon.png';

const Searchbar = () => {
 
    const [query, setQuery] = useState('');

    const handleChange = (e) => {
        const value = e.target.value;
        setQuery(value);
        // Dispatch custom event for Homepage to listen to
        window.dispatchEvent(new CustomEvent('searchChange', { detail: { query: value } }));
    };

    return (
        <div className="searchbar-container">
            <img className='s2' src={Searchicon} alt='Search icon'/>
            <input 
                type='text' 
                className='s1' 
                placeholder={'Search imaging centres'} 
                value={query}
                onChange={handleChange} 
            />
        </div>
    )
  }
  
  export default Searchbar;